import { IsEnum, IsNotEmpty } from 'class-validator';
import { TimeStatus } from './time-status.enum';

export class TimeEditarStatusDto {
  @IsEnum(TimeStatus)
  @IsNotEmpty()
  status: TimeStatus;
}
